'use client'

import { AboutMenuMobile } from '@/components/layout/AboutMenu'
import { PRIMARY_NAV, isNavActive } from '@/lib/nav'
import { track } from '@/lib/tracking'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

// Mobile bottom bar: the same three destinations as the desktop top bar,
// within thumb reach, plus the About menu (an info icon) at the end. A live
// news product shouldn't hide its primary navigation behind a hamburger.
export default function MobileTabBar() {
  const pathname = usePathname()

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-foreground bg-background/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden"
    >
      <ul className="mx-auto flex max-w-md">
        {PRIMARY_NAV.map((item) => {
          const active = isNavActive(item.href, pathname)
          const Icon = item.icon
          return (
            <li key={item.href} className="flex-1">
              <Link
                href={item.href}
                aria-current={active ? 'page' : undefined}
                onClick={() =>
                  track('nav_click', {
                    href: item.href,
                    label: item.label,
                    location: 'mobile_tab_bar',
                  })
                }
                className={`flex min-h-[3.25rem] flex-col items-center justify-center gap-0.5 font-sans text-[11px] transition-colors ${
                  active
                    ? 'font-semibold text-foreground'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                {item.label}
              </Link>
            </li>
          )
        })}
        <li className="flex flex-1">
          <AboutMenuMobile />
        </li>
      </ul>
    </nav>
  )
}
